// Worked examples for the WSJF calculator. Illustrative: invented features and scores
// on the usual 1–20 relative scale. Addressable as #example=<id>.

const r = (low, high) => ({ low, high });

export const EXAMPLES = [
  {
    id: "saas-features",
    name: "Five SaaS features",
    description: "Two clear leaders and a close call in the middle. Illustrative.",
    state: {
      top: 2,
      jobs: [
        { label: "SSO for enterprise", value: r(8, 13), time: r(5, 13), risk: r(3, 8), size: r(5, 13) },
        { label: "Usage dashboard", value: r(5, 8), time: r(2, 5), risk: r(1, 3), size: r(2, 5) },
        { label: "Slack integration", value: r(3, 13), time: r(1, 3), risk: r(2, 8), size: r(3, 8) },
        { label: "Audit log", value: r(3, 5), time: r(8, 13), risk: r(5, 8), size: r(5, 8) },
        { label: "Dark mode", value: r(1, 3), time: r(1, 2), risk: r(1, 1), size: r(2, 3) },
      ],
    },
  },
  {
    id: "discovery-backlog",
    name: "Startup backlog in discovery",
    description: "Wide ranges because customers have not been asked yet. Illustrative.",
    state: {
      top: 1,
      jobs: [
        { label: "Team workspaces", value: r(2, 20), time: r(1, 8), risk: r(5, 13), size: r(5, 13) },
        { label: "Mobile app", value: r(1, 20), time: r(1, 5), risk: r(1, 5), size: r(13, 40) },
        { label: "API access", value: r(5, 13), time: r(3, 8), risk: r(3, 8), size: r(3, 8) },
        { label: "Onboarding checklist", value: r(3, 8), time: r(5, 8), risk: r(2, 5), size: r(1, 3) },
      ],
    },
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) ?? null;
}
